import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getLocalizedPath } from 'utils/languageHelpers';

const ComparisonHistoryEmpty = ({ filter }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const isBookmarkedFilter = filter === 'bookmarked';

  const title = isBookmarkedFilter ? t('ai_compare.empty_bookmarked_title') : t('ai_compare.empty_history_title');

  const description = isBookmarkedFilter
    ? t('ai_compare.empty_bookmarked_description')
    : t('ai_compare.empty_history_description');

  return (
    <div className='empty-state'>
      <div className='empty-icon'>⚖️</div>
      <h3 className='empty-title'>{title}</h3>
      <p className='empty-text'>{description}</p>
      {!isBookmarkedFilter && (
        <button type='button' className='button-primary' onClick={() => history.push(getLocalizedPath('/dashboard'))}>
          {t('ai_compare.browse_products')}
        </button>
      )}
    </div>
  );
};

ComparisonHistoryEmpty.propTypes = {
  filter: PropTypes.string,
};

ComparisonHistoryEmpty.defaultProps = {
  filter: 'all',
};

export default ComparisonHistoryEmpty;
